export const getDocumentCentreStates = (data) => data.documentCentre;

export const selectAccountDocuments = (state) => {
  const { docCentreData } = getDocumentCentreStates(state);
  return docCentreData.data["Account Documentation"];
};
